<template>
	<div id="app" :class="`skin-${skin}`">
		<!-- <img src="./assets/logo.png"> -->
		<router-view />
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'App',
		computed: {
			...mapState({
				skin: state => state.map.skin
			})
		}
	}
</script>

<style>
	body,
	html,
	#app {
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue